import TreePointsMoreIcon from "@assets/icons/Generals/TreePointsMoreIcon"
import { columnsOrderedTable } from "@thelpers/columnsTableHelper"
import CustomDropdown from "@UI/CustomDropdown"
import { Button } from "antd"
import { dropdownCollectionAdministrationItems } from "./dropdownItems"
import FeatureButton from "@tcomponents/FeatureButton/FeatureButton"
import { COLLECTION_ADMINISTRATION_CODES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"

export const columnsCollectionAdministrationTableHelper = ({
    columns = [],
    handleRedirectTo,
    onEnableDisable,
    onDelete,
    onRestore,
    isDelete
}) => {

    const defaultColumns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Status',
            dataIndex: 'charge_status_name',
            key: 'charge_status_name',
            render: (_, record) => {
                return (
                    <span
                        className="collection-administration-table-status"
                        style={{ backgroundColor: record?.status_color, color: '#1A1A1A' }}
                    >
                        {record.charge_status_name}
                    </span>
                )
            }
        },
        {
            dataIndex: "last_charge",
            key: "last_charge",
            title: "Último cobro"
        },
        {
            dataIndex: "next_charge",
            key: "next_charge",
            title: "Próximo cobro"
        },
        {
            dataIndex: "charge_recurrence_frequency_name",
            key: "charge_recurrence_frequency_name",
            title: "Recurrencia"
        },
        {
            title: "Acción",
            width: '225px',
            render: (_, record) => {
                return (
                    <div className="collection-administration-table-action">
                        <FeatureButton
                            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_PAYMENTS_HISTORY}
                            style={{ maxWidth: '165px' }}
                            className="btn-standard-white btn-feature-payments-disabled" 
                            shape="round"
                            onClick={() => handleRedirectTo(`/administration-collection/history/${record?.charge_id}`, {
                                currentCharge: {
                                    ...record
                                }
                            })}
                            tooltip="Ver pagos recibidos"
                        >
                            PAGOS RECIBIDOS
                        </FeatureButton>
                        <CustomDropdown
                            typeShowMenu='click'
                            items={dropdownCollectionAdministrationItems({
                                isDelete,
                                record,
                                status: record.charge_status_code,
                                handleRedirectTo,
                                onRestore,
                                onEnableDisable,
                                onDelete
                            })}
                            styleMenu={{ width: 135 }}
                        >
                            <div>
                                <TreePointsMoreIcon color="#A4A4A4" />
                            </div>
                        </CustomDropdown>
                    </div>
                )
            }
        },
    ]

    return columns.length ? columnsOrderedTable({
        defaultColumns,
        backendColumns: columns,
        titleUpperCase: true,
        ignoreColumns: ['charge_status_code']
    }) : defaultColumns
}

export const columnsCollectionAdministrationTableFilters = ({ currentParams }) => {
    const sort_order = currentParams?.sort_order === 'desc' ? 'descend' : 'ascend'

    return {
        name: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'name' ? sort_order : null,
        }),
        charge_status_name: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'charge_status_name' ? sort_order : null,
        }),
        last_charge: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'last_charge' ? sort_order : null,
        }),
        next_charge: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'next_charge' ? sort_order : null,
        }),
        charge_recurrence_frequency_name: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'charge_recurrence_frequency_name' ? sort_order : null,
        }),
        default: () => ({}),
    }
}